(function () {
  /* by attribute, not by a Liquid-interpolated id: this file is now a static asset. */
  var band = document.querySelector('[data-fp-mascot]');
  if (!band) return;
  var lane = band.querySelector('.fp-mascot__x');
  var dog  = band.querySelector('.fp-mascot__dog');
  /* getAnimations is how the drop is committed. Without it there is no honest
     way to resume the walk mid-stride, and a pup that snapped back to its CSS
     phase on every drop would read as broken — so the whole gesture stays off
     rather than half-working. Baseline since 2020. */
  if (!lane || !dog) return;
  if (!lane.getAnimations) {
    band.classList.add('is-settled');
    band.setAttribute('data-fp-entrance-state', 'started');
    return;
  }

  /* FP40 (2026-10-08): the carried spot is saved as {x,y} px offsets from the bottom-right
     rest under a NEW key. The old 'fp.mascot.y' values were lifts measured from a resting line
     10vh up the page (the retired --fp-rise), so replaying them would park FP over the product
     grid again; they still count as "has carried him" for the hint below. */
  var KEY = 'fp.mascot.pos', OLD_KEY = 'fp.mascot.y';
  var ARRIVED = 'fp.mascot.arrived';   /* the walk-in plays once per visitor (C1) */
  var TAP = 5;            /* px of travel that still counts as a pet, not a drag */
  var TOUCH_TAP = 8;      /* touch needs more: pan-y hands vertical swipes to the page (C3) */
  var GUARD = 8;          /* breathing room above the pup */

  /* A visitor on Reduce Motion keeps a parked pup: it may still be carried and
     petted, and the drop still seeks the walk to the new spot, but it is never
     set running again. */
  var still = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function wantsStillness() { return !!(still && still.matches); }

  /* FP40: the "TAP TO CLAIM" chip and the paw tag are gone (site review B4: one
     on-page offer surface, the join widget). A tap is a pet: bark and recoil,
     nothing advertised. */

  /* ---- the one thing it says ------------------------------------------ */
  /* Said once, out of its own mouth, and never again to anyone who has
     actually picked it up.

     'Has picked it up' needs no new storage: KEY is written ONLY on a real
     carry -- onUp's moved branch -- so its mere presence already records the
     fact. Reusing it means one source for one fact, and it is also right for
     visitors who were carrying the pup before this hint existed: they are not
     told about a gesture they already use.

     SAY_LEAD is measured against the greeting rather than chosen. The settle
     vocabulary runs plant .42s | look .12+.55s | blink at .72s, and ARRIVE_HOLD
     is the frame the pup is DONE. Speaking on that same frame buries the line
     under the blink; a beat after it reads as having finished, then spoken. */
  var say = band.querySelector('.fp-mascot__say');
  var TOLD = 'fp.mascot.told', TELL_LIMIT = 3;
  var SAY_LEAD = 420, SAY_HOLD = 2600, SAY_OUT = 900;
  var sayTimer = 0, spoken = false;

  function carriedBefore() {
    try { return localStorage.getItem(KEY) !== null || localStorage.getItem(OLD_KEY) !== null; } catch (e) { return false; }
  }
  /* The pup re-enters on EVERY page load, so without a cap someone browsing ten
     pages is told ten times -- which stops being a hint and becomes nagging, and
     the theme's own join flow sets the opposite precedent: 'someone who already
     claimed is not pestered again'.

     Three is the whole budget, across visits. Enough that missing the first one
     costs nothing, few enough that it never becomes furniture. Counted only when
     the words ACTUALLY appear, not when they are scheduled, so a page closed
     during the lead-in does not silently spend a telling. Carrying the pup still
     ends it outright, at any count -- that is the thing the hint was for. */
  function toldEnough() {
    try { return (parseInt(localStorage.getItem(TOLD), 10) || 0) >= TELL_LIMIT; }
    catch (e) { return false; }
  }
  function tally() {
    try { localStorage.setItem(TOLD, String((parseInt(localStorage.getItem(TOLD), 10) || 0) + 1)); }
    catch (e) {}
  }
  function hush() {
    window.clearTimeout(sayTimer);
    band.classList.remove('is-saying');
    band.classList.remove('is-hushing');
  }
  function speak() {
    /* `spoken` is set at SCHEDULE time, not at show time. settle() runs again
       on every drop, and two of those inside SAY_LEAD would otherwise queue two
       hints against one timer handle, orphaning the first. */
    if (!say || spoken || carriedBefore() || toldEnough()) return;
    spoken = true;
    sayTimer = window.setTimeout(function () {
      band.classList.add('is-saying');
      tally();
      sayTimer = window.setTimeout(function () {
        band.classList.add('is-hushing');
        sayTimer = window.setTimeout(hush, SAY_OUT);
      }, SAY_HOLD);
    }, SAY_LEAD);
  }

  var held = false, moved = false, pid = null, slop = TAP;
  var startX = 0, startY = 0, dy0 = 0, dx0 = 0, homeTop = 0, homeLeft = 0;

  function num(v) { v = parseFloat(v); return isFinite(v) ? v : 0; }
  function dy() { return num(getComputedStyle(band).getPropertyValue('--fp-dy')); }
  function dx() { return num(getComputedStyle(band).getPropertyValue('--fp-dx')); }
  function setVar(k, v) { band.style.setProperty(k, v + 'px'); }
  function walk() { var a = lane.getAnimations(); return a.length ? a[0] : null; }

  /* Every part that plants has to plant FROM WHERE IT IS. The plant keyframes
     used to hard-code their start angles, which is exactly right for the
     entrance — it lasts a whole number of leg cycles, so the gait leaves each
     diagonal pair at a known angle — and exactly wrong for a drop, where the
     legs have been paddling at half period and are at an arbitrary phase.
     Measured, every drop snapped all four legs 15-18 degrees in one frame.
     Reading the live angle costs one getComputedStyle per part and makes the
     whole-number-of-cycles invariant a nicety rather than a load-bearing one. */
  /* The SVG rig had four independently rotated groups (legs, tail, ear) and the
     plant keyframes had to start from wherever the drag had left them. Finley is
     a baked sprite: one image per frame, no independent limbs, so there is no
     angle to capture and no plant to start. Kept as a no-op because the call
     sites read better than a scatter of conditionals. */
  function captureRig() {}

  /* Removing is-arriving drops the lane back to its static home position, which
     teleports a pup that was dropped mid-entrance by up to half its own body
     width. Measuring the shift and folding it into --fp-dx is exact whatever the
     travel was doing, and costs nothing on the normal path: when the entrance
     has finished its fill already holds the home position, so the delta is 0. */
  function leaveEntrance() {
    if (!band.classList.contains('is-arriving')) return;
    var before = dog.getBoundingClientRect().left;
    band.classList.remove('is-arriving');
    void band.offsetWidth;
    var after = dog.getBoundingClientRect().left;
    var d = before - after;
    if (Math.abs(d) > 0.5) setVar('--fp-dx', clampX(dx() + d));
  }

  /* The ceiling is the sticky header, not the viewport edge. The pup sits at
     z-40 and the header at z-60, so one dragged to the very top would slide
     behind it and read as lost. The header's band is tallest at the top of the
     page, where the announcement bar sits above it, and shrinks once it sticks
     — so keep the tallest seen rather than whatever it measures mid-scroll,
     otherwise scrolling back up swallows a pup parked just under it. */
  var ceiling = GUARD;
  function topGuard() {
    var h = document.querySelector('header');
    if (h) {
      var b = h.getBoundingClientRect().bottom + GUARD;
      if (b > ceiling) ceiling = b;
    }
    return ceiling;
  }

  /* Lift is negative-up: never past the ceiling, never below the resting line,
     which already sits clear of the mobile Add-to-Cart bar. `min` goes POSITIVE
     when the window is too short to honour the merchant's resting height — then
     this pushes the pup back DOWN out of the header, which the old two-branch
     form could not express. */
  function clampY(v) {
    return Math.max(topGuard() - homeTop, Math.min(0, v));
  }

  /* Keep the entire character within the viewport. At rest he is already at the
     right edge, so the useful range is leftwards (negative --fp-dx). */
  function clampX(v) {
    var bounds = dog.getBoundingClientRect();
    return Math.max(GUARD - homeLeft,
      Math.min(window.innerWidth - GUARD - bounds.width - homeLeft, v));
  }

  /* ---- arrival: walk on, plant, look up, blink, stay --------------------- */
  var ARRIVE_HOLD = 1200;   /* plant .42s | look .12+.55s | blink at .72s */
  var settleTimer = 0;
  var footWatch = null;     /* FP40 live fix: the walk-in's give-back watch (arrive) */

  function settle() {
    window.clearTimeout(settleTimer);
    /* Every end of the entrance comes through here: the walk's finish, its 3s fallback and a
       carry (onUp), which cancels the walk so its finish never fires. */
    if (footWatch) { footWatch.disconnect(); footWatch = null; }
    captureRig();
    leaveEntrance();
    band.classList.add('is-settling');
    settleTimer = window.setTimeout(function () {
      band.classList.remove('is-settling');
      band.classList.add('is-settled');
      speak();
    }, ARRIVE_HOLD);
  }

  function arrivedBefore() {
    try { return localStorage.getItem(ARRIVED) === '1'; } catch (e) { return false; }
  }
  function arrive() {
    reclamp();
    /* speak() on this branch too: Reduce Motion skips the entrance entirely,
       so settle() -- where the other call lives -- is never reached. Without
       this the hint would be invisible to exactly the visitors least likely to
       discover a drag gesture by experiment. FP40: so does a visitor who has
       already watched the walk-in once, on any page. */
    if (wantsStillness() || arrivedBefore()) {
      band.classList.add('is-settled');
      band.setAttribute('data-fp-entrance-state', 'started');
      speak(); return;
    }
    band.classList.remove('is-settled');
    band.classList.remove('is-settling');
    void band.offsetWidth;
    band.classList.add('is-arriving');
    band.setAttribute('data-fp-entrance-state', 'started');
    /* FP40 review fix 2026-10-08 (L4): only a walk-in someone can see spends the once-per-visitor
       budget. A desktop-only FP on a phone is display:none (no box) and a phone FP over the footer's
       last lines is visibility:hidden (U1); neither visitor saw him arrive, so a later page plays it.
       FP40 review fix 2026-10-08 (L4, the 30s cap): waitThenArrive() also gets here when the page
       never cleared, and then he walks in at opacity:0 behind an open <dialog>
       (html:has(dialog[open])), an overflow-locked overlay (body[style*="hidden"]) or under the
       footer flag. pageIsClear() is that same test, so it gates the write too. */
    var spent = false;
    if (pageIsClear() && dog.getClientRects().length && getComputedStyle(band).visibility !== 'hidden') {
      try { localStorage.setItem(ARRIVED, '1'); spent = true; } catch (e) {}
    }
    /* FP40 live fix 2026-10-08: FP also hides while a product page's buy block is in his corner
       (data-fp-clear, foodiepaws.js), and that corner is re-measured as he walks in, so on a
       desktop PDP the flag can rise mid-walk although the page was clear when he set off. Then
       nobody saw the walk-in either: give the budget back (only what this walk just wrote; a
       visitor who had arrived before never gets here), and a later page plays it. */
    if (spent && typeof MutationObserver === 'function') {
      footWatch = new MutationObserver(function () {
        if (document.documentElement.getAttribute('data-fp-foot') !== '1') return;
        try { localStorage.removeItem(ARRIVED); } catch (e) {}
        footWatch.disconnect(); footWatch = null;
      });
      footWatch.observe(document.documentElement, { attributes: true, attributeFilter: ['data-fp-foot'] });
    }
    var a = walk();
    /* The class change is driven by the animation's own finish, not a matching
       timer, so the two can never drift apart when --fp-steps is edited. */
    if (a) {
      a.addEventListener('finish', settle, { once: true });
      /* FP40 live fix 2026-10-08: cancelled, not finished (a landscape phone rotated under the
         desktop breakpoint hides him, Reduce Motion switched on mid-walk): settle anyway, or
         .is-arriving stays for good and foodiepaws.js never measures his corner. A carry
         cancels the walk too, after settle() already ran and took .is-arriving away. */
      a.addEventListener('cancel', function () { if (band.classList.contains('is-arriving')) settle(); }, { once: true });
    }
    else window.setTimeout(settle, 3000);
  }

  /* The entrance is the whole point, and on arrival this theme covers the
     screen with the first-order offer dialog — measured at 100% of a 390x844
     phone. Walking on behind that curtain means nobody ever sees it. Wait for
     the page to be its own again; give up waiting after 30s rather than never
     appearing at all. */
  /* FP40 review fix 2026-10-08 (U1): FP is hidden while html[data-fp-foot="1"] (the footer's last
     lines are in view), so the walk-in waits for that too, under the same 30s cap.
     FP40 review fix 2026-10-08 (U1, every width): at every width now, like the fp-mascot.css hide
     (it was phones only; from 744px he covered the last legal links at maximum scroll). */
  function pageIsClear() {
    if (document.querySelector('dialog[open]')) return false;
    if (document.documentElement.getAttribute('data-fp-foot') === '1') return false;
    return getComputedStyle(document.body).overflow !== 'hidden'
        && getComputedStyle(document.documentElement).overflow !== 'hidden';
  }

  function onDown(e) {
    if (e.button > 0) return;
    /* No `walk()` guard here any more. It used to bail when there was no
       travel animation, which was safe while the pup walked forever — now the
       settled pup has none, and that guard would have disabled the drag
       outright the moment the entrance finished. */
    hush();       /* they are picking it up, which is what the hint was asking for */
    held = true; moved = false; pid = e.pointerId;
    slop = e.pointerType === 'touch' ? TOUCH_TAP : TAP;
    startX = e.clientX; startY = e.clientY;
    dy0 = dy(); dx0 = dx();
    homeTop = band.getBoundingClientRect().top - dy0;
    homeLeft = dog.getBoundingClientRect().left - dx0;
    /* The entrance is NOT paused here. It used to be, and a pet — pointerdown
       plus pointerup with no movement — then froze the pup forever: nothing in
       this file ever called play(), and settle() is armed by the travel
       animation's own `finish` event, which a paused animation can never fire.
       Measured, the pup churned its legs on the spot 13 seconds later, 85px
       short of centre, still in profile, and a second tap did not recover it.
       Pausing on the first onMove that crosses TAP instead makes a pet
       structurally incapable of touching the entrance, rather than relying on
       every future onUp branch remembering to resume it. */
    band.classList.add('is-held');
    band.classList.remove('is-landing');
    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onUp);
    e.preventDefault();
  }

  function onMove(e) {
    if (!held || e.pointerId !== pid) return;
    var ddx = e.clientX - startX, ddy = e.clientY - startY;
    if (!moved && (Math.abs(ddx) > slop || Math.abs(ddy) > slop)) {
      moved = true;
      var a = walk();          /* a real carry: now the travel may stop */
      if (a) a.pause();
    }
    /* FP40: nothing moves inside the slop, so a pet never nudges him. */
    if (!moved) return;
    setVar('--fp-dx', clampX(dx0 + ddx));
    setVar('--fp-dy', clampY(dy0 + ddy));
    e.preventDefault();
  }

  function onUp(e) {
    if (!held || e.pointerId !== pid) return;
    /* A pan-y scroll that started on FP arrives here as pointercancel with no
       carry: let go quietly — a scroll is not a pet, so no bark. */
    var cancelled = e.type === 'pointercancel';
    held = false;
    window.removeEventListener('pointermove', onMove);
    window.removeEventListener('pointerup', onUp);
    window.removeEventListener('pointercancel', onUp);
    band.classList.remove('is-held');

    if (moved) {
      /* The carried distance is no longer folded back into a walk phase,
         because there is no walk to fold it into: --fp-dx simply KEEPS the
         offset and the pup stays where it was put. It then plants, looks up
         and blinks at whoever moved it — the same greeting it gave on arrival,
         which is what "walks on from where you drop it" turns into once the
         pup is not supposed to walk any more. */
      band.classList.add('is-landing');
      window.setTimeout(function () { band.classList.remove('is-landing'); }, 340);
      savePos();
      settle();
    } else if (!cancelled) {
      /* --fp-dx is NOT reset here any more: it is the pup's position now, not a
         scratch value borrowed for the duration of a drag. Zeroing it would
         teleport a pup back to centre for the crime of being petted. */
      /* Sound is owned by foodiepaws.js — see note 4 at the top of this file.
         The recoil plays on every pet even when the clip is inside its
         anti-spam window, so a second tap is never silent AND still. */
      if (typeof window.fpBark === 'function') window.fpBark(700);
      band.classList.remove('is-barking');
      void band.offsetWidth;
      band.classList.add('is-barking');
      window.setTimeout(function () { band.classList.remove('is-barking'); }, 460);
    }
  }

  function savePos() {
    /* The first carry ends the join-bubble lift (fp-mascot.css, data-fp-moved): fold the band's
       drop back into --fp-dy, with the bottom transition off, so he stays exactly where he was put. */
    if (!band.hasAttribute('data-fp-moved')) {
      var before = band.getBoundingClientRect().top;
      band.style.transition = 'none';
      band.setAttribute('data-fp-moved', '');
      var shift = band.getBoundingClientRect().top - before;
      if (Math.abs(shift) > 0.5) setVar('--fp-dy', Math.round(dy() - shift));
      void band.offsetWidth;
      band.style.transition = '';
    }
    try { localStorage.setItem(KEY, JSON.stringify({ x: Math.round(dx()), y: Math.round(dy()) })); } catch (err) {}
  }

  /* Resizing or rotating a phone must keep the pup on screen. FP40: the old
     "lift above #fpHeroMobile" step is gone — this sprite never renders on the
     homepage (FP v2 does), and lifting him off his corner is what C1 removed. */
  function reclamp() {
    /* Desktop-only FP on a phone is display:none: no box to measure, nothing to clamp. */
    if (!dog.getClientRects().length) return;
    var cur = dy();
    homeTop = band.getBoundingClientRect().top - cur;
    var next = clampY(cur);
    if (next !== dy()) setVar('--fp-dy', next);
    var curX = dx();
    homeLeft = dog.getBoundingClientRect().left - curX;
    var nextX = clampX(curX);
    if (nextX !== curX) setVar('--fp-dx', nextX);
  }

  /* FP40: the rest is dy 0 in the corner (the vh "rise" and the resolveRest()
     step that converted it to px are gone). Restore a saved carry, clamped to
     this viewport: reclamp() below re-measures both axes. */
  try {
    var saved = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (saved && isFinite(saved.x) && isFinite(saved.y) && dog.getClientRects().length) {
      band.setAttribute('data-fp-moved', '');
      homeTop = band.getBoundingClientRect().top;
      setVar('--fp-dy', clampY(Number(saved.y)));
      homeLeft = dog.getBoundingClientRect().left;
      setVar('--fp-dx', clampX(Number(saved.x)));
    }
  } catch (err) {}

  /* Always, not only after a restore: the resting height comes from CSS and can
     be taller than a short window allows. */
  reclamp();

  /* The theme editor re-renders this section in place, re-running the script.
     Element listeners die with the old node; a window listener would not. */
  if (window.fpMascotResize) window.removeEventListener('resize', window.fpMascotResize);
  window.fpMascotResize = reclamp;
  window.addEventListener('resize', reclamp);

  dog.addEventListener('pointerdown', onDown);

  /* Boot the entrance. Poll rather than listen: the four things that can cover
     the page — the offer dialog, the cart drawer, the mobile menu, the search
     overlay — announce themselves in three different ways, and a 400ms tick
     costs nothing next to knowing all of their selectors and staying right
     about them. */
  var waited = 0;
  function waitThenArrive() {
    if (!band.isConnected) return;
    if (held) { window.setTimeout(waitThenArrive, 400); return; }
    if (pageIsClear() || waited >= 30000) { arrive(); return; }
    waited += 400;
    window.setTimeout(waitThenArrive, 400);
  }
  var entranceStarted = false;
  function startWhenReady() {
    if (entranceStarted || band.getAttribute('data-fp-sheet-state') !== 'ready') return;
    entranceStarted = true;
    band.removeEventListener('fp:mascot-ready', startWhenReady);
    waitThenArrive();
  }
  band.addEventListener('fp:mascot-ready', startWhenReady);
  startWhenReady();
}());
